import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Loan from 'loan';


const StyledTableCell = withStyles(theme => ({
  head: {
    color: theme.palette.common.white,
    fontFamily: 'NordeaSansSmall'
  },
  body: {
    fontSize: 12,
    fontFamily: 'NordeaSansSmall'
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
      fontFamily: 'NordeaSansSmall'
    },
  },
}))(TableRow);

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    padding: '25px 5px',
    height: '100%'
  },
  label: {
    color: 'rgb(0,0,160)',
    fontSize: '18px',
    fontWeight: '400'
  },
  sliderBox: {
    paddingTop: "32px",
    height: "52px",
    margin: '0 32px'
  },
  sliderBoxInner: {
    display: 'flex'
  },
  sliderBoxRight: {
    marginLeft: 'auto',
    order: 2
  },
  tabel: {
    height: '100%',
    width: '100%',
    fontFamily: 'NordeaSansSmall'
  }
}));

const PaymentPlan = props => {

  const classes = useStyles();

  if (props.intrest === 0) {
    console.log("no intrest")
    return null;
  }

  if (props.amount === 0) {
    console.log("no amoint")
    return null;
  }

  if (props.years === 0) {
    console.log("no years")
    return null;
  }

  let loan = new Loan({
    type: props.config.misc.mortgageType,
    pay_every: 'month',
    principal: Number(props.amount),
    interest_rate: props.intrest / 100,
    invoice_fee: Number(props.config.misc.invoice_fee),
    initial_fee: Number(props.config.misc.initial_fee),
    instalments: Number(props.years) * 12
  });

  return (
    <div className={classes.wrapper}>
      <h2 style={{ textAlign: 'center', fontSize: '18px', color: `#${props.config.misc.color}`, fontWeight: 400 }}>Betalplan</h2>
      <Table className={classes.tabel} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell style={{ backgroundColor: `${props.config.misc.backgroundColor}`, color: 'white', fontFamily: 'NordeaSansSmall' }} >Period</TableCell>
            <TableCell style={{ backgroundColor: `${props.config.misc.backgroundColor}`, color: 'white', fontFamily: 'NordeaSansSmall' }}>Betalning</TableCell>
            <TableCell style={{ backgroundColor: `${props.config.misc.backgroundColor}`, color: 'white', fontFamily: 'NordeaSansSmall' }}>Ränta</TableCell>
            <TableCell style={{ backgroundColor: `${props.config.misc.backgroundColor}`, color: 'white', fontFamily: 'NordeaSansSmall' }}>Amortering</TableCell>
            <TableCell style={{ backgroundColor: `${props.config.misc.backgroundColor}`, color: 'white', fontFamily: 'NordeaSansSmall' }}>Restskuld</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loan.getPaymentPlan().map(row => (
            <StyledTableRow key={row.principal}>
              <StyledTableCell component="th" scope="row">
                {row.instalment + 1}
              </StyledTableCell>
              <StyledTableCell>{(Number(row.to_pay.toFixed(0))).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</StyledTableCell>
              <StyledTableCell>{(Number(row.interest.toFixed(0)).toLocaleString("sv-SE", props.sekFormat).replace(',00', ''))}</StyledTableCell>
              <StyledTableCell>{(Number(row.amortization.toFixed(0))).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</StyledTableCell>
              <StyledTableCell>{(Number(row.principal.toFixed(0))).toLocaleString("sv-SE", props.sekFormat).replace(',00', '')}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </div>)
}

export default PaymentPlan; 